import {Command} from "../command";
import {CommandType} from "../commandType";
import {EditorMode, EstimateCostRowPopupParams} from "../../components/estimate-cost-row-popup/estimate-cost-row-popup";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {PopupMode} from "../popups/popup";
import {Application} from "../application";
import * as ko from "knockout";

export class CreateEstimateCostRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.CreateEstimateCostRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        return true;
    });

    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });

    execute(data: { insertAbove?: boolean, insertToTheEnd?: boolean, editorMode: EditorMode, fromCostbook: boolean, title?: string, price?: number, period?: string, bufferItemId?: number }): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        let dfd = $.Deferred();
        
        if(!data){
            this.app.popupsManager.show<EstimateCostRowPopupParams>(PopupType.estimateCostRow, false).done(() => {
                dfd.resolve(params.result);
            }).fail(() => {
                dfd.reject()
            });
            
            return dfd.promise();
        }

        let params = <EstimateCostRowPopupParams>{
            popupMode: data.fromCostbook ? PopupMode.NewFromCostRow : PopupMode.New,
            editorMode: data.editorMode,
            insertAbove: data.insertAbove,
            insertToTheEnd: data.insertToTheEnd,
            title: data.title,
            price: data.price,
            period: data.period,
        };


        this.app.popupsManager.show<EstimateCostRowPopupParams>(PopupType.estimateCostRow, false, params).done(() => {
            dfd.resolve(params.result);
        }).fail(() => {
            dfd.reject()
        });

        return dfd.promise();
    }
    

    name = "Create New Subtotal Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/createEstimateCostRowCommand.ts